import { Injectable } from '@angular/core';
import { RequestOptionsArgs, Response } from '@angular/http';
import { IHttpInterceptor } from '@covalent/http-deprec';
import { TdLoadingService, LoadingMode, LoadingType, LoadingStrategy } from '@covalent/core';
import {UserData} from '../globals/userData.global';
import { Headers } from '@angular/http';
import {delay} from "rxjs/operators";

@Injectable()
export class HttpLoadingInterceptor implements IHttpInterceptor {

  loaderCount: number;

  constructor(private spinnerLoadingService:TdLoadingService,
              private progressBarLoadingService:TdLoadingService,
              private userData:UserData) {
    this.spinnerLoadingService.create({
      name: 'spinnerLoadingConfig',
      mode: LoadingMode.Indeterminate,
      type: LoadingType.Linear,
      color: 'primary'
    });
    this.progressBarLoadingService.create({
      name: 'progressBarLoadingConfig',
      mode: LoadingMode.Indeterminate,
      type: LoadingType.Circular,
      color: 'primary'
    });
    this.loaderCount = 0;
  }

  onRequest(requestOptions: RequestOptionsArgs): RequestOptionsArgs {
    let clientToken = this.userData.getCsrf();
    if (requestOptions != null ) {
      if(requestOptions.headers != null) {
        requestOptions.headers.append('XSRF-TOKEN', clientToken);
      }
      else {
        requestOptions.headers = new Headers({ 'XSRF-TOKEN': clientToken });
      }

    }
    this.loaderCount++;
    console.log("onRequest: " + requestOptions.url);
    console.log("loaderCount: " + this.loaderCount);
    if (requestOptions.url.indexOf("sendId") <0) {
      this.progressBarLoadingService.register('progressBarLoadingConfig');
      this.spinnerLoadingService.register('spinnerLoadingConfig');
    }
    return requestOptions;
  }


  onResponse(response: Response): Response {
    if(this.userData.getCsrf()==(undefined||null)||response.headers.get("XSRF-TOKEN")) {
      this.userData.setCsrf(response.headers.get("XSRF-TOKEN"));
    }

    console.log(this.userData.csrf);

    this.loaderCount--;
    console.log("onResponse: " + response.url);
    console.log("loaderCount: " + this.loaderCount);
    if (response.url.indexOf("sendId")<0) {
      this.progressBarLoadingService.resolveAll('progressBarLoadingConfig');
      this.spinnerLoadingService.resolveAll('spinnerLoadingConfig');
    }
    return response;
  }

  onResponseError(error: Response): Response {
    this.progressBarLoadingService.resolveAll('progressBarLoadingConfig');
    this.spinnerLoadingService.resolveAll('spinnerLoadingConfig');
    return error;
  }

}
